"use client";

import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

import { ButtonGroup } from "ui/core/button-group";

type ChartLayoutType = "overview" | "financialReport" | "stockSentiment";

type ButtonGroupProps = {
  type: ChartLayoutType;
  lang: Lang;
  onButtonClick: (value: string) => void;
  activeId?: string;
};

const getOptionMap = ({ lang }: { lang: Lang }) => {
  const { t } = getTranslations(lang);
  return {
    overview: [
      { id: "Q", name: t.analysis.shared.dateOption.quarterly },
      { id: "Y", name: t.analysis.shared.dateOption.annually },
    ],
    financialReport: [
      { id: "Q", name: t.analysis.shared.dateOption.quarterly },
      { id: "4Q", name: t.analysis.shared.dateOption.fourQ },
      { id: "Y", name: t.analysis.shared.dateOption.annually },
    ],
    stockSentiment: [],
  };
};

const ChartTimeFrameButtonGroup = ({
  lang,
  type,
  activeId,
  onButtonClick,
}: ButtonGroupProps) => {
  const options = getOptionMap({ lang })[type];

  const maxWidth = options.length * 130;

  return (
    <div className="sticky top-4 z-50 mb-4 flex w-full justify-center sm:static">
      <ButtonGroup
        className={`w-full max-w-[${maxWidth}px]`}
        options={options}
        onButtonClick={onButtonClick}
        activeId={activeId}
      />
    </div>
  );
};

export default ChartTimeFrameButtonGroup;
